import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { getLocalStorageObject } from "./util/helper";
import { useToast } from "components/common/custom-toast/Toast";

const GlobalStorageListener = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const toast = useToast();

  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === "user" || e.key === null) {
        const user = getLocalStorageObject("user");
        const isBrokerLoggedIn = user?.brokerLoggedIn === true;

        if (!isBrokerLoggedIn) {
          const path = location.pathname;
          if (path.startsWith("/terminal") || path.startsWith("/algo")) {
            toast.error("Broker account disconnected. Please login again.");
            navigate("/broker-login");
          }
        }
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [location.pathname, navigate]);

  return null;
};

export default GlobalStorageListener;
